/** 华住外呼日志：当前页面菜单与本次请求操作（由 request 拦截器带给后端）。 */

let currentMenu = ''

export function setErpOpenApiSourceMenu (menu) {
  currentMenu = menu == null ? '' : String(menu).trim()
}

export function getErpOpenApiSourceMenu () {
  return currentMenu
}

/** 单次请求的操作名；在发请求前设置，拦截器读取后清空。 */
let pendingAction = ''

export function setErpOpenApiSourceAction (action) {
  pendingAction = action == null ? '' : String(action).trim()
}

export function consumeErpOpenApiSourceAction () {
  const action = pendingAction
  pendingAction = ''
  return action
}

export function withErpOpenApiAction (action, config) {
  return Object.assign({}, config || {}, { erpSourceAction: action })
}

/** 从 axios / request 拦截器 reject 的错误中取出后端 message（与华住 sync 失败文案一致）。 */
export function parseErpApiErrorMessage (err, fallback = '华住同步失败') {
  if (!err) return fallback
  const data = err.data || (err.response && err.response.data)
  const backend = data && (data.message || data.msg)
  if (backend) return String(backend)
  if (err.message && err.message !== 'error') return err.message
  return fallback
}
